import { render, staticRenderFns } from "./HighlightedCode.vue?vue&type=template&id=e1944d38&"
import script from "./HighlightedCode.vue?vue&type=script&lang=js&"
export * from "./HighlightedCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports